export const EMPLOYEES = "57,000";
export const GLOBAL_PICKUP_POINTS = "108,000";
export const PARCELS_DELIVERED = "2.1 Billion";
export const REVENUE = "15.7 Billion €*";
